<progress-spinner *ngIf="isLoading"></progress-spinner>
<div *ngIf="!isLoading">
  <nrwl-common-about [dataSource]="inputData"></nrwl-common-about>
</div>
